import React, { useEffect, useState } from 'react';
import './DetailPlayingMobile.scss';
import firebase from 'firebase';
import { db } from '../../firebase';
import { useDataLayerValue } from '../../DataLayer';
import SliderPlaying from '../MenuRight/Bottom/SliderPlaying';
import { ICONS } from '../../constants/icons';

function DetailPlayingMobile(props) {
    let [{ lang, song_playing, loop, shuffle, playing, playing_loading, playlists, playback_rate }, dispatch] = useDataLayerValue();
    const [songDetail, setSongDetail] = useState({});
    useEffect(() => {
        if (props.id) {
            db.collection("songs").where("key", "==", `${props.id}`)
                .get()
                .then(async function (doc) {
                    if (!doc.empty) {
                        let song = { id: doc.docs[0].id, ...doc.docs[0].data() };
                        setSongDetail(song);
                        if (song_playing.id !== song.id) {
                            dispatch({
                                type: 'SET_SONG_PLAYING',
                                song_playing: song
                            });
                            dispatch({
                                type: 'SET_PLAYING_LOADING',
                                playing_loading: true
                            });
                            dispatch({
                                type: 'SET_PLAYING',
                                playing: true
                            });
                            //update view of song
                            let docData = {
                                view: parseInt(doc.data()['view']) + 1,
                                updated_at: firebase.firestore.Timestamp.now(),
                            };
                            await db.collection("songs").doc(doc.id).update(docData);
                        }
                        props.handleSetLoadingPage(false);
                    }
                })
                .catch(function (error) {
                    console.log("Error getting detail song.");
                });
        }
    }, [props.id]);

    const handleShuffle = () => {
        dispatch({
            type: 'SET_SHUFFLE',
            shuffle: !shuffle
        });
    };

    const handlePlaying = () => {
        if (!playing_loading) {
            dispatch({
                type: 'SET_PLAYING',
                playing: !playing
            });
        }

    };


    const handleRepeat = () => {
        if (loop === 0) {
            dispatch({
                type: 'SET_LOOP',
                loop: 2
            });
            return;
        }
        if (loop === 2) {
            dispatch({
                type: 'SET_LOOP',
                loop: 1
            });
        } else {
            dispatch({
                type: 'SET_LOOP',
                loop: 0
            });
        }

    };

    const handlePlayingSongPreviousOrNext = (typeAction) => {
        const arrAction = ['previous', 'next'];
        if (!arrAction.includes(typeAction)) { return; }
        const indexSongNow = playlists.indexOf(song_playing.id);
        const indexSongNext = typeAction === 'previous' ? (indexSongNow - 1) : (indexSongNow + 1);
        const idSong = (playlists[indexSongNext] !== undefined && playlists[indexSongNext] !== null ? playlists[indexSongNext] : playlists[indexSongNow]);
        if (idSong) {
            dispatch({
                type: 'SET_PLAYING_SONG_BY_ID',
                playing_song_by_id: idSong
            });
            dispatch({
                type: 'SET_PLAYING_LOADING',
                playing_loading: true
            });
        }
    };

    const handlePlaybackRate = () => {
        if (parseFloat(playback_rate) < 3) {
            dispatch({
                type: 'SET_PLAYBACK_RATE',
                playback_rate: parseFloat(parseFloat(playback_rate) + 0.25).toFixed(2)
            });
        } else {
            dispatch({
                type: 'SET_PLAYBACK_RATE',
                playback_rate: parseFloat(1).toFixed(2)
            });
        }
    };

    return (
        <div className="detail-playing-mobile" style={{ backgroundColor: `${songDetail.bg_color ? songDetail.bg_color : '#121212'}` }}>

            <div className="images-song">
                <img aria-hidden="false" draggable="false" loading="eager" style={{ boxShadow: `0px 4px 60px rgba(0  ,0 ,0, 0.5) , 0px 4px 30px ${songDetail.bg_color}` }} src={songDetail.avatar ? songDetail.avatar : ''} alt={lang === 'en' ? songDetail.name_en : songDetail.name_vi} />
            </div>
            <div className="sumary-song">
                <div className="name-song">
                    <h2><span>{lang === 'en' ? songDetail.name_en : songDetail.name_vi}</span></h2>
                    <h2><span>{lang === 'en' ? songDetail.name_en : songDetail.name_vi}</span></h2>
                </div>
                <div className="singer-song">
                    <h4>{lang === 'en' ? songDetail.singer : songDetail.singer}</h4>
                </div>
            </div>
            <div className="control-slider-playing">
                <SliderPlaying totalTime={song_playing.time} isMobile={true} isMobileShowTime={true} />
            </div>
            <div className="now-playing-bar__center">
                <div className="player-controls">
                    <div className="player-controls__buttons">
                        <div className="control-button-wrapper">
                            <button className={`control-button ${shuffle && 'btn-active-shuffle'}`} title="Enable shuffle" onClick={handleShuffle}>
                                <svg height="20" viewBox="0 -2 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z" />
                                    <path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button  control-button--disabled" title="Previous" aria-label="Previous" disabled="" onClick={() => handlePlayingSongPreviousOrNext('previous')}>
                                <svg height="28" viewBox="1 1 13 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.5 3.5A.5.5 0 0 0 4 4v8a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5z" />
                                    <path d="M4.903 8.697l6.364 3.692c.54.313 1.232-.066 1.232-.697V4.308c0-.63-.692-1.01-1.232-.696L4.903 7.304a.802.802 0 0 0 0 1.393z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button  control-button--circled" title="Play" aria-label="Play" onClick={handlePlaying}>
                                {
                                    playing_loading ? (<img src={ICONS.loading} className="loading" alt="icon loading" />) : (playing ? (<svg height="28" role="img" width="28" viewBox="0 0 25 24"><rect x="5" y="3" width="4" height="18" fill="currentColor"></rect><rect x="15" y="3" width="4" height="18" fill="currentColor"></rect></svg>) : (<svg height="28" role="img" width="28" viewBox="0 0 24 24"><polygon points="21.57 12 5.98 3 5.98 21 21.57 12" fill="currentColor"></polygon></svg>))
                                }
                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button " title="Next" aria-label="Next" onClick={() => handlePlayingSongPreviousOrNext('next')}>
                                <svg height="28" viewBox="1 1 13 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z" />
                                    <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper" >
                            <button className={`control-button ${loop !== 0 ? `btn-active-repeat type-repeat-${parseInt(loop)}` : ''}`} title="Enable repeat" aria-label="Enable repeat" onClick={handleRepeat}>
                                <svg height="20" viewBox="0 -1 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                    <path d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="player-controls">
                    <div className="player-controls__buttons">
                        <div className="control-button-wrapper">
                            <button className="control-button" title="Enable shuffle" >
                                <svg height="24" role="img" width="24" viewBox="0 0 24 24" ariaLabelledby="connect" ><title id="connect">
                                    Connect to Devices</title>
                                    <path d="M1,4.5 L1,16.5 C1,17.05 1.45,17.5 2,17.5 L8.999,17.5 L8.999,16.5 L2,16.5 L2,4.5 L8.999,4.5 L8.999,3.5 L2,3.5 C1.45,3.5 1,3.95 1,4.5 Z M4.999,20 C4.999,20.275 5.224,20.5 5.499,20.5 L8.999,20.5 L8.999,19.5 L5.499,19.5 C5.224,19.5 4.999,19.725 4.999,20 Z M22,3.5 L13,3.5 C12.45,3.5 12,3.95 12,4.5 L12,19.5 C12,20.05 12.45,20.5 13,20.5 L22,20.5 C22.55,20.5 23,20.05 23,19.5 L23,4.5 C23,3.95 22.55,3.5 22,3.5 Z M13.016,19.5 L13,4.516 L21.984,4.516 L22,19.484 L13.016,19.5 Z M17.5,11.5 C15.843,11.5 14.5,12.843 14.5,14.5 C14.5,16.157 15.843,17.5 17.5,17.5 C19.157,17.5 20.5,16.157 20.5,14.5 C20.5,12.843 19.157,11.5 17.5,11.5 Z M17.5,16.5 C16.397,16.5 15.5,15.603 15.5,14.5 C15.5,13.397 16.397,12.5 17.5,12.5 C18.603,12.5 19.5,13.397 19.5,14.5 C19.5,15.603 18.603,16.5 17.5,16.5 Z M17.5,8.5 C18.052,8.5 18.5,8.052 18.5,7.5 C18.5,6.948 18.052,6.5 17.5,6.5 C16.948,6.5 16.5,6.948 16.5,7.5 C16.5,8.053 16.948,8.5 17.5,8.5 Z" fill="currentColor" fillRule="evenodd"></path>
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                </svg>
                            </button>

                        </div>
                        <div className="control-button-wrapper" >
                            <button className="control-button" onClick={handlePlaybackRate}>
                                <label htmlFor="" className="speed-playing">{playback_rate}x</label>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetailPlayingMobile;